import ArticleCard from '@/components/base/ArticleCard';
import type { Article } from '@/mocks/articles';

interface ArticleGridProps {
  title: string;
  articles: Article[];
  viewAllLink?: string;
}

export default function ArticleGrid({ title, articles, viewAllLink }: ArticleGridProps) {
  return (
    <section className="w-full">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-xl font-bold font-heading text-foreground-950">
          {title}
        </h2>
        {viewAllLink && (
          <a
            href={viewAllLink}
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            更多
            <i className="ri-arrow-right-line text-xs"></i>
          </a>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}